import { version } from '../../../../package.json';

export const WEB_PLATFORM_VERSION = version ?? '#.##.#';

export const WEB_PLATFORM_IS_BUILD_MODE = process.env.NODE_ENV === 'production';

export const WEB_PLATFORM_ENVIRONMENT =
  process.env.REACT_APP_ENVIRONMENT ?? 'development';

export const WEB_PLATFORM_IS_ENVIRONMENT = {
  development: WEB_PLATFORM_ENVIRONMENT === 'development',
  staging: WEB_PLATFORM_ENVIRONMENT === 'staging',
  production: WEB_PLATFORM_ENVIRONMENT === 'production',
};
